export function capitalizeWords(value) {
  return String(value ?? "").replace(/\b([A-Za-zÀ-ÖØ-öø-ÿĀ-žЀ-ӿ])([^\s]*)/g, (_, first, rest) => {
    return `${first.toUpperCase()}${rest.toLowerCase()}`;
  });
}

export function normalizeEmail(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function isStrictEmail(value) {
  const email = normalizeEmail(value);
  if (!email) return false;
  if (email.length < 6 || email.length > 100) return false;
  return /^(?!.*\.\.)([A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/.test(email);
}
